const Backbone = require('backbone');
var ProjectModel = Backbone.Model.extend({
	urlRoot: '/app/api/project',
	api: 'local',
	defaults: {
		archived: false,
		name: '',
		description: ''
	},
	validate: function(attrs) {
		if (!attrs.name) {
			return 'Project Name is required.';
		}
	}
});

module.exports = ProjectModel;
